const PriceUnavailableMessage = () => (
  <div className="price-unavailable-message">
    <p>Produto com preço indisponível</p>
  </div>
)

export default PriceUnavailableMessage
